// Utility functions for drag and drop operations
// CREATED: Centralized drag & drop utilities to eliminate duplicated code
// - createInvisibleDragImage: Creates invisible drag preview to hide browser's default cursor
// - calculateDragOffset: Calculates Y-axis offset between cursor and element during drag start
// FIXED: dragImage now appended to portal-root (not document.body) and cleaned up via dragend event
// UPDATED: Use shared getPortalRoot() helper instead of inline portal root lookup
// FIXED: Guard against missing e.dataTransfer to prevent DOM node and event listener leaks

import { getPortalRoot } from './portalUtils';

export function createInvisibleDragImage(e: React.DragEvent): void {
  if (!e.dataTransfer) return;

  const container = getPortalRoot();
  const dragImage = document.createElement('div');
  dragImage.style.cssText = 'position:absolute;top:-9999px;width:1px;height:1px;opacity:0;pointer-events:none;';
  container.appendChild(dragImage);
  e.dataTransfer.setDragImage(dragImage, 0, 0);

  const cleanup = () => {
    if (container.contains(dragImage)) {
      container.removeChild(dragImage);
    }
  };
  document.addEventListener('dragend', cleanup, { once: true, capture: true });
}

export function calculateDragOffset(e: React.DragEvent | React.TouchEvent, element: HTMLElement): number {
  const clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
  const rect = element.getBoundingClientRect();
  return clientY - rect.top;
}
